import { useSearch } from '@tanstack/react-router';
import QRApproveAccess from '@/components/access/QRApproveAccess';
import { DefaultActions, type DefaultAction } from '@/utils/access/grantHelpers';

const DenyComponent = () => {
	const { token: denyToken, approve_token: approveToken, action } = useSearch({ from: '/access/$token/deny' });
	return <QRApproveAccess approveToken={approveToken} denyToken={denyToken} defaultAction={action} />;
};

export const Route = createFileRoute({
	component: DenyComponent,
	validateSearch: (search) => ({
		token: search.token as string,
		approve_token: search.approve_token as string | undefined,
		action: (search.action as DefaultAction | undefined) ?? DefaultActions.Deny,
	}),
});
